var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb__pagetop js__pagetop"},[_c('a',{directives:[{name:"click-2-Top",rawName:"v-click-2-Top"}],attrs:{"href":"javascript:;"}},[_vm._v("↑TOP")])])}
var staticRenderFns = []

export { render, staticRenderFns }